import { purify } from '@vfit/shared/themes';
import { EditorialCard } from '../EditorialCard';
import { IInstallationAddress } from './installationAddress.models';
import * as S from './installationAddress.style';

export const InstallationAddress = ({ address, styled, title }: IInstallationAddress) => {
  const pTitle = purify([title || ''])?.[0];

  return (
    <S.Section styled={styled} hasTitle={!!pTitle}>
      {pTitle && <S.Title dangerouslySetInnerHTML={{ __html: pTitle }} />}
      <EditorialCard.AddressUserData {...address} />
    </S.Section>
  );
};

